import React from 'react';
import Frame from '../../views/Frame';
import createSprite from '../../../lib/createSprite';
import Utils from '../../../lib/utils';
import CommonAnimations from '../../../animations/common';

var LeonSpeech = React.createClass({

    propTypes: {
        backgroundKey: React.PropTypes.string,
        className: React.PropTypes.string
    },

    contextTypes: {
        language: React.PropTypes.string,
    },

    timeline: null,
    sprites: null,

    getDefaultProps: function()
    {
        return {
            backgroundKey: 'introBg',
            layers: [
                {
                    backgroundKey: 'pipesCentered',
                },
                {
                    backgroundKey: 'darkLinesBackground',
                },
            ],
            className: 'intro-leon',
            bottomTile: true,
            bottomTileColor: 'darkGreen',
        };
    },

    render: function()
    {
        return (
            <Frame
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                {...this.props}
            >
            </Frame>
        );
    },

    build: function(container, timeline)
    {
        this.sprites = {
            container: container
        };
        this.timeline = timeline;

        this.buildObjects();
        this.animateObjects();
    },

    play: function()
    {
        this.animateObjects();
    },

    pause: function()
    {

    },

    destroy: function()
    {
        this.sprites = null;
    },

    buildObjects: function()
    {
        var context = this.context;
        var props = this.props;
        var sprites = this.sprites;
        var objs = props.objs;
        var container = sprites.container;

        var width = props.width;
        var height = props.height;

        // BLACK FRAME -------------------------------------
        var blackFrame = sprites.blackFrame = new PIXI.Graphics();
        blackFrame.beginFill(0);
        blackFrame.drawRect(0, 0, width, height);
        blackFrame.endFill();
        blackFrame.alpha = 0.4;
        container.addChild(blackFrame);

        // PIPES -------------------------------------------
        var pipesObj = objs.pipes;
        var pipes = sprites.pipes = createSprite(pipesObj);
        Utils.setSizeAndPositionFromRefSize(pipes, props.width, props.height, pipesObj);
        pipes.scale.x *= -1;
        container.addChild(pipes);

        // STAR --------------------------------------------
        // var override = {
        //     position: {
        //         x: '50%',
        //         y: '50%'
        //     }
        // };
        //
        // var starTextureObj = objs.starTexture;
        // var starTexture = sprites.starTexture = createSprite(starTextureObj);
        // Utils.setSizeAndPositionFromRefSize(starTexture, props.width, props.height, _.extend(starTextureObj, override));
        //
        // var starMaskObj = objs.starMask;
        // var starMask = sprites.starMask = createSprite(starMaskObj);
        // Utils.setSizeAndPositionFromRefSize(starMask, props.width, props.height, _.extend(starMaskObj, override));
        // starTexture.mask = starMask;
        //
        // container.addChild(starMask);
        // container.addChild(starTexture);

        // VOLUME ------------------------------------------
        // var volumeIconObj = objs.volumeIcon;
        // var volumeIcon = sprites.volumeIcon = createSprite(volumeIconObj);
        // Utils.setSizeAndPositionFromRefSize(volumeIcon, props.width, props.height, volumeIconObj);
        // container.addChild(volumeIcon);
        //
        // let volumeTextObj = objs.volumeTitleFr;
        // if (context.language === 'en') {
        //     volumeTextObj = objs.volumeTitleEn;
        // }
        // var volumeText = sprites.volumeText = createSprite(volumeTextObj);
        // Utils.setSizeAndPositionFromRefSize(volumeText, props.width, props.height, volumeTextObj);
        // container.addChild(volumeText);
    },

    animateObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;

        var width = props.width;
        var height = props.height;

        var timeline = this.timeline;

        var volumeText = this.volumeText;

        // VOLUME ICON --------------------------------
        // var volumeAnimation = CommonAnimations.getMovieclipTimeline(sprites.volumeIcon, {
        //     fps: 8,
        //     yoyo: true
        // });
        // timeline.add(volumeAnimation, 0);
        // timeline.to([sprites.starTexture, sprites.volumeIcon], 1, {
        //     alpha: 1
        // });

        // TIMED ANIMATION ----------------------------
        // timeline.add(new TimelineMax({
        //         yoyo: true,
        //         repeat: 1,
        //         repeatDelay: 3,
        //         onComplete: _.bind(function(){
        //             volumeAnimation.pause();
        //         }, this)
        //     })
        //     .fromTo([sprites.starTexture, sprites.volumeIcon, sprites.volumeText], 1, {
        //         alpha: 0
        //     },{
        //         alpha: 1
        //     }, 0)
        // , 0);

        timeline.addCallback(function () {
            this.onStartLeonSpeech();
        }, 1, [], this)

        // PIPES --------------------------------------
        timeline.add(new TimelineMax({repeat: -1, repeatDelay: 1})
            .to(sprites.pipes, 0.01, {
                repeat: 120,
                yoyo: true,
                x: '+='+width * 0.004,
            })
        , 0);

        // STAR ---------------------------------------
        // timeline.to(sprites.starMask.scale, 1, {
        //     x: '-=0.1',
        //     y: '-=0.1',
        //     ease: Power1.easeInOut,
        //     yoyo: true,
        //     repeat: -1
        // }, 0);

        if (this.props.onAnimationReady) {
            this.props.onAnimationReady(timeline);
        }
    },

    onStartLeonSpeech: function() {
        if (this.props.onResumeMessageBox)
        {
            this.props.onResumeMessageBox();
        }
    }

});

module.exports = LeonSpeech;



// WEBPACK FOOTER //
// ./js/components/frames/0-Intro/2-LeonSpeech.jsx